/** Тема оформления: светлая / тёмная / как в системе. Выбор хранится на телефоне. */
export type Theme = 'system' | 'light' | 'dark';

const KEY = 'saleus-theme';

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

/** Ставит атрибут на <html>: токены в index.css переключаются по нему. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
  void syncStatusBar(theme);
}

export function saveTheme(theme: Theme): void {
  try { localStorage.setItem(KEY, theme); } catch { /* хранилище закрыто */ }
  applyTheme(theme);
}

/** Цвет иконок строки состояния под тему. Лениво и молча: в браузере пакета нет. */
async function syncStatusBar(theme: Theme): Promise<void> {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (!Capacitor.isNativePlatform()) return;
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    const light = theme === 'light' || (theme === 'system' && matchMedia('(prefers-color-scheme: light)').matches);
    await StatusBar.setStyle({ style: light ? Style.Light : Style.Dark });
  } catch { /* не оболочка телефона */ }
}
